/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * @module plugins/inline-popup
 */
export default ['bold', 'italic', '|', 'ul', 'ol', 'eraser', '|', 'fontsize', 'brush', 'paragraph', '---', 'image', 'table', '\n', 'link', '|', 'align', '|', 'undo', 'redo', '|', 'copyformat', 'fullsize', '---', 'dots'];